import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {API_URL} from '../services/token.service';
import 'rxjs/add/operator/toPromise';

@Injectable()

export class _RuleNdfCurrencyService {

  constructor(private http: HttpClient) { }

  GetRuleNdfCurrency(){
    return this.http.get<any[]>(`${API_URL}/rule-ndf-currencies`).toPromise().then((result) => {
      return result;
    });
  }

  CreateRuleNdfCurrency(ndfCurrency){
    return this.http.post<any>(`${API_URL}/rule-ndf-currencies`, [ ndfCurrency ]).toPromise().then((result) => {
      return result;
    });
  }

  UpdateRuleNdfCurrency(ndfCurrency){
    return this.http.put<any>(`${API_URL}/rule-ndf-currencies`, [ ndfCurrency ]).toPromise().then((result) => {
      return result;
    });
  }

  DeleteRuleNdfCurrency(ndfCurrencyId){
    return this.http.delete<any>(`${API_URL}/rule-ndf-currencies/` + ndfCurrencyId).toPromise().then((result) => {
      return result;
    });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/ng1-services/rule-ndf-currency.service.ts